import { render, staticRenderFns } from "./PopupHabitsAcceptSuggestion.vue?vue&type=template&id=29b28b30"
import script from "./PopupHabitsAcceptSuggestion.vue?vue&type=script&lang=js"
export * from "./PopupHabitsAcceptSuggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports